import { render } from "./Contact.vue?vue&type=template&id=2c78941c"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Pages/Contact.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c78941c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c78941c', __exports__)) {
    api.reload('2c78941c', __exports__)
  }
  
  module.hot.accept("./Contact.vue?vue&type=template&id=2c78941c", () => {
    api.rerender('2c78941c', render)
  })

}


export default __exports__